<ng-container *ngIf="reminderDef">
  <form #reminderForm="ngForm" class="rd-editor">
    <header class="rd-header">
      <h4 class="rd-title">{{ reminderDef.name }}</h4>
    </header>
    <mat-tab-group class="rd-tabs" (selectedTabChange)="selectedTabChange($event)">
      <mat-tab [label]="'EMAIL' | translate">
        <ng-container *ngIf="reminderDef.emailConfig">
          <div class="rd-channel">
            <mat-checkbox
              name="emailEnabled"
              [ngModel]="isChannelEnabled('email')"
              (ngModelChange)="setChannelEnabled('email', $event)"
              class="rd-enabled"
            >
              {{ "ENABLED" | translate }}
            </mat-checkbox>
            <ng-container
              [ngTemplateOutlet]="scheduleEditor"
              [ngTemplateOutletContext]="{ channel: 'email' }"
            >
            </ng-container>
            <hr class="rd-divider" />

            <mat-form-field appearance="outline" class="rd-full">
              <mat-label>{{ "EMAIL_SUBJECT" | translate }}</mat-label>
              <input
                matInput
                [placeholder]="'EMAIL_SUBJECT' | translate"
                name="emailSubject"
                [(ngModel)]="reminderDef.emailConfig.subject"
              />
            </mat-form-field>
            <app-boarding-quick-links-editor
              *ngIf="reminderDef.type === 'PET_BOARDING'"
              #emailQuicklinksMessageEditor
              [selectedLinks]="reminderDef.emailConfig.links"
              [(editorContent)]="reminderDef.emailConfig.body"
              messageType="EMAIL"
            >
            </app-boarding-quick-links-editor>
            <app-appointment-quick-links-editor
              *ngIf="reminderDef.type === 'APPOINTMENT'"
              #emailQuicklinksMessageEditor
              [selectedLinks]="reminderDef.emailConfig.links"
              [(editorContent)]="reminderDef.emailConfig.body"
              messageType="EMAIL"
            >
            </app-appointment-quick-links-editor>
            <app-vaccination-quick-links-editor
              *ngIf="reminderDef.type === 'VACCINATION'"
              #emailQuicklinksMessageEditor
              [(editorContent)]="reminderDef.emailConfig.body"
              messageType="EMAIL"
            >
            </app-vaccination-quick-links-editor>
            <app-pet-quick-links-editor
              *ngIf="reminderDef.type === 'PET_BIRTHDAY'"
              #emailQuicklinksMessageEditor
              [(editorContent)]="reminderDef.emailConfig.body"
              messageType="EMAIL"
            >
            </app-pet-quick-links-editor>
            <app-deposit-quick-links-editor
              *ngIf="reminderDef.type === 'DEPOSIT'"
              #emailQuicklinksMessageEditor
              [(editorContent)]="reminderDef.emailConfig.body"
              messageType="EMAIL"
            >
            </app-deposit-quick-links-editor>
            <app-customer-quick-links-editor
              *ngIf="reminderDef.type === 'CUSTOMERS_LAST_INVOICE'"
              #emailQuicklinksMessageEditor
              [(editorContent)]="reminderDef.emailConfig.body"
              messageType="EMAIL"
            >
            </app-customer-quick-links-editor>
          </div>
        </ng-container>
      </mat-tab>

      <mat-tab [label]="'SMS' | translate">
        <ng-container *ngIf="reminderDef.smsConfig">
          <div class="rd-channel">
            <mat-checkbox
              name="smsEnabled"
              [ngModel]="isChannelEnabled('sms')"
              (ngModelChange)="setChannelEnabled('sms', $event)"
              [disabled]="isSmsLocked()"
              class="rd-enabled"
            >
              {{ "ENABLED" | translate }}
            </mat-checkbox>
            <p *ngIf="isSmsLocked()" class="mat-text-secondary rd-note">
              <b>{{ "WHATSAPP_SMS_BACKUP_LABEL" | translate }}.</b> {{ "WHATSAPP_SMS_BACKUP_INFO" | translate }}
            </p>
            <ng-container
              [ngTemplateOutlet]="scheduleEditor"
              [ngTemplateOutletContext]="{ channel: 'sms' }"
            >
            </ng-container>
            <hr class="rd-divider" />
            <h6 class="rd-section-title">{{ "SMS_BODY" | translate }}</h6>
            <app-appointment-quick-links-editor
              #quickLinksEditorV2Component
              [selectedLinks]="reminderDef.smsConfig.links"
              *ngIf="
                reminderDef.type === 'APPOINTMENT' ||
                reminderDef.type === 'PET_BOARDING'
              "
              [(editorContent)]="reminderDef.smsConfig.text"
              messageType="SMS"
            >
            </app-appointment-quick-links-editor>
            <app-vaccination-quick-links-editor
              #quickLinksEditorV2Component
              *ngIf="reminderDef.type === 'VACCINATION'"
              [(editorContent)]="reminderDef.smsConfig.text"
              messageType="SMS"
            >
            </app-vaccination-quick-links-editor>
            <app-customer-quick-links-editor
              #quickLinksEditorV2Component
              *ngIf="reminderDef.type === 'CUSTOMERS_LAST_INVOICE'"
              [(editorContent)]="reminderDef.smsConfig.text"
              messageType="SMS"
            >
            </app-customer-quick-links-editor>
            <app-deposit-quick-links-editor
              #quickLinksEditorV2Component
              *ngIf="reminderDef.type === 'DEPOSIT'"
              [(editorContent)]="reminderDef.smsConfig.text"
              messageType="SMS"
            >
            </app-deposit-quick-links-editor>
            <app-pet-quick-links-editor
              #quickLinksEditorV2Component
              *ngIf="reminderDef.type === 'PET_BIRTHDAY'"
              [(editorContent)]="reminderDef.smsConfig.text"
              messageType="SMS"
            >
            </app-pet-quick-links-editor>
          </div>
        </ng-container>
      </mat-tab>
      <mat-tab *ngIf="hasWhatsAppTab()" [label]="'WHATSAPP' | translate">
        <div class="rd-channel">
          <app-whatsapp-reminder-tab
            [reminderType]="reminderDef.type"
            [enabled]="!!reminderDef.whatsAppConfig?.enabled"
            [locked]="!isWhatsAppSendingEnabled"
            (enabledChange)="setWhatsAppEnabled($event)"
          ></app-whatsapp-reminder-tab>
          <ng-container *ngIf="reminderDef.whatsAppConfig?.enabled && reminderDef.smsConfig">
            <hr class="rd-divider" />
            <p class="mat-text-secondary rd-note">{{ 'WHATSAPP_REMINDER_SHARED_SCHEDULE' | translate }}</p>
            <ng-container
              [ngTemplateOutlet]="scheduleEditor"
              [ngTemplateOutletContext]="{ channel: 'sms' }"
            >
            </ng-container>
          </ng-container>
        </div>
      </mat-tab>
    </mat-tab-group>

    <ng-template #scheduleEditor let-channel="channel">
      <section class="rd-schedules">
        <div class="rd-schedules-head">
          <h6 class="rd-section-title">Choose when this {{ channel === 'email' ? 'email' : 'SMS' }} will be sent.</h6>
          <button
            mat-stroked-button
            color="primary"
            (click)="addSchedule(channel)"
            [disabled]="!canAddSchedule(channel)"
            type="button"
          >
            <mat-icon>add</mat-icon>
            {{ "ADD_NEW" | translate }}
          </button>
        </div>

        <div
          *ngFor="
            let schedule of getSchedules(channel);
            trackBy: trackBySchedule;
            index as i
          "
          class="rd-schedule-row"
        >
          <mat-form-field appearance="outline" class="rd-schedule-when">
            <mat-label>When to send</mat-label>
            <mat-select
              [name]="channel + 'Schedule' + i"
              [ngModel]="schedule"
              [compareWith]="schedulesMatch"
              (ngModelChange)="updateSchedule(channel, schedule, $event)"
            >
              <mat-option
                *ngFor="
                  let option of scheduleOptionsFor(schedule);
                  trackBy: trackByScheduleOption
                "
                [value]="option.schedule"
              >
                {{ option.label }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <div *ngIf="schedule.scheduleType !== 'IMMEDIATE'" class="rd-schedule-time">
            <app-time-select
              [placeholder]="'TIME_TO_SEND_REMINDER' | translate"
              [date]="scheduleTimeAsDate(schedule)"
              [interval]="15"
              [required]="true"
              (dateChange)="setScheduleTimeFromDate(channel, schedule, $event)"
            >
            </app-time-select>
          </div>

          <p *ngIf="schedule.scheduleType === 'IMMEDIATE'" class="rd-schedule-time mat-text-secondary">
            This reminder will be sent immediately.
          </p>

          <button
            type="button"
            (click)="removeSchedule(channel, schedule)"
            mat-icon-button
            class="rd-schedule-remove"
            [attr.aria-label]="'Remove ' + formatSchedule(schedule)"
            matTooltip="Remove schedule"
          >
            <mat-icon role="img">delete</mat-icon>
          </button>
        </div>

        <mat-error *ngIf="isChannelMissingSchedule(channel)">
          {{ "AT_LEAST_ONE_SCHEDULE_REQUIRED" | translate }}
        </mat-error>
        <mat-error *ngIf="hasMissingScheduleTime(channel)">
          Choose a send time for every schedule except immediate reminders.
        </mat-error>
      </section>
    </ng-template>
    <footer class="rd-footer">
      <button
        mat-raised-button
        color="accent"
        type="button"
        (click)="update()"
        [disabled]="!reminderForm.form.valid || !canSave()"
      >
        {{ "UPDATE" | translate }}
      </button>
    </footer>
  </form>
</ng-container>
